export default class UserModel {
  constructor(data) {
    if (!data) {
      // eslint-disable-next-line no-param-reassign
      data = {};
    }

    this.id = data.id || 0;
    this.full_name = data.full_name || '';
    this.email = data.email || '';
    this.phone_number = data.phone_number || '';
    this.phone_country_code = data.phone_country_code || '';
    this.phone_number_e164 = data.phone_number_e164 || '';

    this.email_verified = data.email_verified || false;
    this.is_admin = data.is_admin || false;
    this.is_organization_admin = data.is_organization_admin || false;
    this.is_site_admin = data.is_site_admin || false;
    this.organization_id = data.organization_id || null;
    // eslint-disable-next-line no-nested-ternary
    this.permission = data.is_admin ? 'Admin' : data.is_organization_admin ? 'Organization Admin' : data.is_site_admin ? 'Site Admin' : 'Read-Only';
    this.organization_name = data.organization_name || '';
    this.allowed_to_remove_files = data.allowed_to_remove_files || false;
    this.last_login = data.last_login ? new Date(data.last_login) : null;
    this.loginsWithoutMfa = data.login_without_mfa_count || 0;
    this.hasMfaConfigured = data.has_mfa_configured || false;
    this.allowed_to_access_management = data.allowed_to_access_management || false;
    this.allowed_programmatic_access = data.allowed_programmatic_access || false;
    this.sites = data.sites || [];
  }
}
